import React from 'react';
// import Link from 'next/link';
import Layout from "../components/Layout";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import { fetchEntries } from '../utils/contentfulBlogs';
import SectionGetQuoteForm from '../components/landingSections/SectionGetQuoteForm';
import Loadable from '@loadable/component';
import SectionEstimateFormSuntuity from '../components/landingSections/SectionEstimateFormSuntuity';
// import Scrollspy from "react-scrollspy";
// import Scroll from '../pages/Scroll';
interface Props {
    landingPage: any;
}
export const LandingPage = (props: Props) => {
    // console.log(props.landingPage?.layout);
    return (
        <Layout>

            {(props.landingPage?.layout?.bannerLayout == 'suntuity' && (props.landingPage?.layout?.bannerLayoutTwo != 'layouttwo' && props.landingPage?.layout?.bannerLayoutTwo != 'layoutone')) && (
                <div className={"landing-banner-wrap bg-white " + props.landingPage?.layout?.bannerLayout + "-banner-wrap"} id="estimate-form-wrap">
                    <section className={"grid place-center home landing-solar-panels-bay-area-ca pt-12 xxs:pt-20 " + props.landingPage?.layout?.bannerLayout}
                        style={{ backgroundImage: "url(" + props.landingPage?.bannerImage?.fields?.file?.url + ")" }}>

                        <div className="px-4 pb-8 xxs:pb-0 pt-10 md:pt-6 container m-auto grid place-center">
                            <div
                                className="grid grid-cols-1 2md:grid-cols-5 gap-x-0 gap-2 md:gap-4 xxs:py-8 banner-height place-center items-start justify-center">
                                <div className="xl:pt-20 sm:py-8 xl:px-14 xl:pl-16 col-span-3">
                                    <h1
                                        className="capitalize text-3xl xxs:text-4xl md:text-5xl font-primaryBold text-white max-w-xl 2md:max-w-lg lg:max-w-2xl xl:mr-20">
                                        {props.landingPage?.heading1}
                                        {props.landingPage?.heading2 ?
                                            <span className="text-primary">{' '}{props.landingPage?.heading2}</span>
                                            : ''
                                        }
                                    </h1>
                                    {props.landingPage?.description1 ? <p className="text-base xxs:text-xl text-gray-200 pt-3 lg:max-w-xl md:max-w-lg banner-desc-one">
                                        {props.landingPage?.description1}
                                    </p> : ''
                                    }
                                    {props.landingPage?.description2 ?
                                        <p className="text-base xxs:text-xl text-gray-200 py-3 lg:max-w-xl md:max-w-lg  banner-desc-two">
                                            {props.landingPage?.description2}
                                        </p> : ''
                                    }
                                </div>
                                <div className={"xl:px-6 col-span-2 flex flex-row justify-center " + (props.landingPage?.layout?.bannerLayout == 'suntuity' ? "quote-form_new-jersey" : "")} id="quote-form">
                                    <div className="bg-white 2md:rounded-xl max-w-48 shadow-lg-g">

                                        {props.landingPage?.sections && (
                                            props.landingPage?.sections.map((item: any, index: number) => {
                                                // Here import dynamic component!
                                                if (item.fields.type == 'SectionGetQuoteForm') {
                                                    return <SectionGetQuoteForm key={index} />;
                                                }
                                                if (item.fields.type == 'SectionEstimateFormSuntuity') {
                                                    return <SectionEstimateFormSuntuity key={index} />;
                                                }
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )}

{(props.landingPage?.layout?.bannerLayout == 'suntuity' && props.landingPage?.layout?.bannerLayoutTwo == 'layouttwo') && (
             <div className={"landing-banner-wrap bg-white " + props.landingPage?.layout?.bannerLayout+"-banner-wrap"} id="estimate-form-wrap">
             <section className={"grid place-center home landing-solar-panels-bay-area-ca pt-12 xxs:pt-20 banner-custom-form banner-section-layouttwo " + props.landingPage?.layout?.bannerLayout}
                 style={{ backgroundImage: "url(" + props.landingPage?.bannerImage?.fields?.file?.url + ")" }}>

                 <div className="px-4 pb-8 xxs:pb-0 pt-10 md:pt-6 container m-auto grid place-center">
                     <div className="">
                         <div className="xl:pt-12 sm:py-8 px-2 md:px-12 xl:px-12 text-center">
                             <h1
                                 className="capitalize text-3xl md:text-3xl xl:text-5xl font-primaryBold text-white">
                                 {props.landingPage?.heading1}
                                 {props.landingPage?.heading2 ?
                                     <span className="text-primary">{' '}{props.landingPage?.heading2}</span>
                                     : ''
                                 }
                             </h1>
                             <div className='px-2 md:px-8 lg:px-20'>
                             {props.landingPage?.description1 ? <p className="text-lg xxs:text-xl xl:text-2xl text-gray-200 pt-3 banner-desc-one">
                                 {props.landingPage?.description1}
                             </p> : ''
                             }
                             {props.landingPage?.description2 ?
                                 <p className="text-base xxs:text-xl text-gray-200 py-3 banner-desc-two">
                                     {props.landingPage?.description2}
                                 </p> : ''
                             }
                             </div>
                            
                         </div>
                         <div className={"xl:px-6 flex justify-center " + (props.landingPage?.layout?.bannerLayoutTwo == 'layouttwo' ? "quote-form_transparent_new-jersey" : " ")} id="quote-form">
                             
                             <SectionEstimateFormSuntuity/>
                         </div>
                     </div>
                 </div>
             </section>
         </div>
          )}

            {(props.landingPage?.layout?.bannerLayout != 'suntuity') && (
                <div className="landing-banner-wrap bg-white">
                    <section className="grid place-center home landing-solar-panels-bay-area-ca pt-12 xxs:pt-20 banner-section-layouttwo"
                        style={{ backgroundImage: "url(" + props.landingPage?.bannerImage?.fields?.file?.url + ")" }}>

                        <div className="px-4 pb-8 xxs:pb-0 pt-10 md:pt-6 container m-auto grid place-center">
                            <div
                                className="grid grid-cols-1 2md:grid-cols-2 gap-4 xxs:py-8 banner-height place-center items-start justify-center">
                                <div className="xl:pt-20 sm:py-8 xl:px-14 xl:pl-16">
                                    <h1
                                        className="capitalize text-3xl xxs:text-4xl lg:text-5xl font-primaryBold text-white max-w-xl 2md:max-w-lg lg:max-w-xl xl:mr-20">
                                        {props.landingPage?.heading1}
                                        {props.landingPage?.heading2 ?
                                            <span className="text-primary">{' '}{props.landingPage?.heading2}</span>
                                            : ''
                                        }
                                    </h1>
                                    {props.landingPage?.description1 ? <p className="text-base xxs:text-xl text-gray-200 pt-3 lg:max-w-xl md:max-w-lg banner-desc-one">
                                        {props.landingPage?.description1}
                                    </p> : ''
                                    }
                                    {props.landingPage?.description2 ?
                                        <p className="text-base xxs:text-xl text-gray-200 py-3 lg:max-w-xl md:max-w-lg  banner-desc-two">
                                            {props.landingPage?.description2}
                                        </p> : ''
                                    }

                                </div>
                                <div className="xl:px-14 xl:pl-16 flex flex-row justify-center" id="quote-form">
                                    <div className="bg-white 2md:rounded-xl max-w-48 shadow-lg-g">

                                        {props.landingPage?.sections && (
                                            props.landingPage?.sections.map((item: any, index: number) => {
                                                // Here import dynamic component!
                                                if (item.fields.type == 'SectionGetQuoteForm') {
                                                    return <SectionGetQuoteForm key={index} />;
                                                }
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )}
            {props.landingPage?.sections && (
                props.landingPage?.sections.map((item: any, index: number) => {
                    // Here import dynamic component!
                    if (item.fields.type != 'SectionGetQuoteForm' && item.fields.type != 'SectionGetQuoteFormNewJersey' && item.fields.type != 'SectionEstimateFormSuntuity') {
                        const Module = Loadable(() => import(`../components/landingSections/${item.fields.type}`))
                        return (
                            <Module
                                key={index}
                                props={props}
                            />
                        )
                    }
                })
            )}
        </Layout >
    );
};

export default LandingPage;

export async function getStaticProps({ params }: { params: any }) {
    const res: any = await fetchEntries({ content_type: 'landingPages', "fields.slug": params.slug });
    let landingPage = null;
    if (res.length > 0) {
        landingPage = { ...res[0].fields, createdAt: res[0].sys.createdAt, updatedAt: res[0].sys.updatedAt }
    }
    return {
        props: {
            landingPage
        },
    }
}

export async function getStaticPaths() {
    const res: any = await fetchEntries({ content_type: 'landingPages' });
    const landingPages = await res.map((l: any) => {
        return l.fields
    });
    return {
        paths: landingPages.map((page: any) => {
            return {
                params: {
                    slug: page.slug,
                },
            }
        }),
        fallback: false,
    };
}
